import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';
import ViewPhotosSwiper from './view-photos-swiper';
import { SOCIAL_QR_CODES } from '../constants/constants';

const QRCodePage = () => {
  const qrImages = SOCIAL_QR_CODES.map(qr => qr.img);

  return (
    <Box w="100%" display="flex" flexDirection="column">
      <Heading as="h1" size="lg" p={4} textAlign="center">
        Connect with Us
      </Heading>
      <Box flex={1}>
        <ViewPhotosSwiper
          photos={qrImages}
          selectedIndex={0}
          autoPlay={false}
          showZoom={false}
          showNavigation={false}
        />
      </Box>
    </Box>
  );
};

export default QRCodePage;
